import React from 'react';
import { connect } from 'react-redux';
import NavHeader from './NavHeader/NavHeader';
import '../styles/Container.css';
import '../styles/Ranking.css';
import AlertToastr from './Shared/AlertToastr';

const mapStateToProps = (state) => {
    const currentUser = state.session.find(x => x.type === 'SET_CURRENT_USER');
    return {
        currentUser: currentUser ? currentUser.currentUser : null
    };
}


class Container extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            toast: null
        };
    }

    setAddToast = (addToast) => {
        window.__GLOBAL_TOAST__ = addToast;
        this.setState({ toast: addToast });
    }
    render() {
        return (
            <React.Fragment>
                {<NavHeader router={this.props.router} currentUser={this.props.currentUser} toast={this.state.toast} />}
                <div id="container">
                    <div className="container-body">
                        {this.props.children}
                    </div>
                    <AlertToastr setAddToast={this.setAddToast} />
                </div>
            </React.Fragment>
        );
    }
}

export default connect(
    mapStateToProps
)(Container);